import CommonActionType from '../actiontype/common.actiontype'
import UtilService from '../services/util.service';
import { hideHeader, hideFooter, showFooter, showHeader, showLoader, hideLoader } from './app.action';
import { setUserAuthorized, setLoggedInMobileNumber, setSelectedNumber, setAppLoginToken } from './authorization.action';
import { proceedAccToUserPreference, openRegistrationsPage, openComplainsPage } from './sso-modal.action';
import AppLoginService from '../services/app-login.service';
import AccountType from '../enums/number-type.enum';
import { UserAction } from '../constants/user-action.constant';
import { setUserPreference } from './dnd-app.action';
import Page from '../constants/page.enum';
import PlatformType from '../enums/platform-type.enum';
import AuthService from '../services/auth.service';


export const resetState = () => {
    return { type: CommonActionType.RESET_STATE }
}

export const prepareForPlatform = () => dispatch => {
    dispatch(decidePlatformType());
    if (UtilService.isMobileApp()) {
        dispatch(prepareForMobileApp());
    } else {
        dispatch(prepareForWeb());
    }
}

const decidePlatformType = () => dispatch => {
    switch (true) {
        case UtilService.isIOSWebview():
            dispatch(setPlatformType(PlatformType.IOS_WEBVIEW));
            break;
        case UtilService.isAndroidWebview():
            dispatch(setPlatformType(PlatformType.ANDROID_WEBVIEW));
            break;
        case UtilService.isAndroidMsite():
            dispatch(setPlatformType(PlatformType.ANDROID_MSITE));
            break;
        case UtilService.isIOSMsite():
            dispatch(setPlatformType(PlatformType.IOS_MSITE));
            break;
        case UtilService.isOtherMsite():
            dispatch(setPlatformType(PlatformType.OTHER_MSITE));
            break;
        default:
            dispatch(setPlatformType(PlatformType.WEB));
    }
}

const setPlatformType = (platformType) => {
    return {
        type: CommonActionType.SET_PLATFORM_TYPE,
        payload: platformType
    }
}

export const prepareForMobileApp = () => dispatch => {
    dispatch(hideHeader());
    dispatch(hideFooter());
    dispatch(setUserAuthorized());
}

export const decideAndOpenLoggedInPage = () => (dispatch, getState) => {
    const state = getState();
    const page = UtilService.getPageForApp();
    const accType = UtilService.getSelectedAccTypeForApp();
    const selectedNumber = state.userInfo.selectedNumber;
    if (selectedNumber) {
        switch (page) {
            case Page.REGISTRATION_FORM:
                if (accType === AccountType.POSTPAID || accType === AccountType.PREPAID) {
                    dispatch(setUserPreference(UserAction.MOBILE_REGISTRATION));
                } else if (accType === AccountType.FIXED_LINE) {
                    dispatch(setUserPreference(UserAction.FIXEDLINE_REGISTRATION));
                } else {
                    // Take back to initial app page    
                    UtilService.closeCurrentMobileWindow()
                    // throw new Error("Account type error")
                }
                dispatch(openRegistrationsPage());
                break;
            case Page.COMPLAINT_FORM:
                dispatch(setUserPreference(UserAction.COMPLAINT));
                dispatch(proceedAccToUserPreference(selectedNumber));
                break;
            default:
                // Take back to initial app page
                UtilService.closeCurrentMobileWindow()
            // throw new Error("Unknown page error")
        }

    } else {
        // Take back to initial app page    
        UtilService.closeCurrentMobileWindow()
        // throw new Error("Selected number not set error")
    }
}

export const prepareForWeb = () => dispatch => {
    dispatch(showHeader());
    dispatch(showFooter());
}
